export default "__VITE_ASSET__59b346a5__"